import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SidebarModal } from '../../../components/common/Sidebar/Sidebar';

import { useTranslation } from 'react-i18next';
import { ErrorToast } from '../../../components/common/Toasts/Toasts';
import { H4, P2, P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { FlexBetween } from '../../../styles/stylesStyled';
import { Box, Dot, Label, Text, WithSocial } from '../SettingsStyled';
import { TwoFAEmail } from '../TwoFAEmail';
import { TwoFAInit } from '../TwoFAInit';
import { TwoFALogin } from '../TwoFALogin';
import { enableVerificationStatus } from '../Settings.actions';
import { PasswordSteps } from './PasswordSteps';
import { useAppSelector } from '../../../app/hooks';
import { Button } from '../../../components';
import { Flexed } from '../../../styles/GlobalComponents';
import { Icon, IconEdit } from '../../../styles/Icons';

export const Security = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [step, setStep] = useState(1);

  const [passwordStep, setPasswordStep] = useState(1);

  const {
    verificationStatus,
    signIn2FAEnabled,
    signInEmailCodeVerificationEnabled
  } = useAppSelector((state) => state.settings);
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const renderDots = () => {
    let content = [];
    for (let i = 0; i < 8; i++) {
      content.push(<Dot key={i} />);
    }

    return content;
  };

  return (
    <>
      <Box style={{ opacity: user?.creationType === 1 ? '' : '0.5' }}>
        <FlexBetween>
          <div>
            <P2>{t('security.password')}</P2>
            <P2>{renderDots()}</P2>
          </div>
          {user?.creationType === 1 ? (
            <Button
              color='#000'
              maxWidth='150px'
              style={{
                padding: ' 0 20px',
                cursor: user?.creationType === 1 ? 'pointer' : 'not-allowed'
              }}
              // negative
              onClick={() => {
                setIsOpen(user?.creationType === 1 ? true : false);
                setPasswordStep(1);
              }}>
              <Flexed justifyCenter>
                {' '}
                <Icon mr='10'>
                  {' '}
                  <IconEdit />
                </Icon>
                {t('security.edit')}
              </Flexed>
            </Button>
          ) : (
            <WithSocial>
              {t('security.registered')} <br />
              {t('security.with_social')}
            </WithSocial>
          )}
        </FlexBetween>
      </Box>
      <H4 mt='25' color={color.colors.neutral900}>
        {t('security.email_verification')}
      </H4>
      {!signInEmailCodeVerificationEnabled && (
        <P2 mb='15' mt='10' color={color.colors.neutral900}>
          {t('security.protecting_your_account')}
        </P2>
      )}
      <Box>
        <FlexBetween>
          <P2> {t('security.email_verification_at_login')}</P2>
          <Button
            color='#000'
            maxWidth='150px'
            style={{
              padding: ' 0 20px',
              cursor: 'pointer'
            }}
            disabled={signInEmailCodeVerificationEnabled}
            onClick={() => {
              if (!signInEmailCodeVerificationEnabled) {
                setIsOpen4(!isOpen4);
              }
            }}>
            {signInEmailCodeVerificationEnabled
              ? t('security.enabled')
              : t('security.enable')}
          </Button>
        </FlexBetween>
      </Box>
      <P2 mb='10' mt='25' color={color.colors.neutral900}>
        {t('security.two_factor_authenticator')}
      </P2>

      <Box>
        <FlexBetween>
          <P2>{t('security.setup2FA')}</P2>
          <Button
            maxWidth='150px'
            color='#000'
            style={{
              padding: ' 0 20px',
              cursor: 'pointer'
            }}
            onClick={() => {
              if (!verificationStatus) {
                setStep(1);
                setIsOpen2(!isOpen2);
                dispatch(enableVerificationStatus());
              } else {
                setStep(2);
                setIsOpen2(!isOpen2);
              }
            }}>
            {!verificationStatus ? t('security.setup') : t('security.remove')}
          </Button>
        </FlexBetween>
      </Box>
      <Box>
        <div>
          <FlexBetween>
            <P2>{t('security.2FA_verification_at_login')} </P2>
            <Button
              color='#000'
              maxWidth='150px'
              style={{
                padding: ' 0 20px',
                cursor: 'pointer'
              }}
              onClick={() => {
                if (!verificationStatus) {
                  ErrorToast(t('security.enable_2fa_authenticator'));
                } else {
                  setIsOpen3(!isOpen3);
                }
              }}>
              {!signIn2FAEnabled ? t('security.enable') : t('security.disable')}
            </Button>
          </FlexBetween>
        </div>
      </Box>

      <P2 m='20px 0' color={color.colors.neutral900}>
        {t('security.why_is_it_necessary')} <br /> <br />
        {t('security.2FA_info')}
      </P2>
      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={t('security.change_your_password')}
        sidebarWidth={'508px'}>
        <PasswordSteps step={passwordStep} setStep={setPasswordStep} />
      </SidebarModal>

      <SidebarModal
        isOpen={isOpen2}
        setOpen={setIsOpen2}
        title={t('security.verification')}
        sidebarWidth={'511px'}>
        <TwoFAInit step={step} setStep={setStep} setIsOpen={setIsOpen2} />
      </SidebarModal>

      <SidebarModal
        isOpen={isOpen3}
        setOpen={setIsOpen3}
        title={t('security.2fa_title')}
        sidebarWidth={'511px'}>
        <TwoFALogin setIsOpen={setIsOpen3} />
      </SidebarModal>
      <SidebarModal
        isOpen={isOpen4}
        setOpen={setIsOpen4}
        title={t('security.email_verification_setup')}
        sidebarWidth={'511px'}>
        <TwoFAEmail setIsOpen={setIsOpen4} />
      </SidebarModal>
    </>
  );
};
